import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import religionService from "../Services/Service";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import "../styles/Religion.css";
import {
  Button,
  Modal,
  Box,
  TextField,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";

import ModeEditOutlineRoundedIcon from "@mui/icons-material/ModeEditOutlineRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const ReligionManager = () => {
  const [religions, setReligions] = useState([]);
  const [form, setForm] = useState({ id: "0", name: "" });
  const [editing, setEditing] = useState(false);
  const [open, setOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const navigate = useNavigate();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    religionService.setApiUrl(
      sessionStorage.getItem("APIUrl") + "/api/Religion",
    );
    fetchReligions();
  }, []);

  const fetchReligions = async () => {
    const res = await religionService.getAll();
    setReligions(res.data);
  };

  const clear = () => {
    setForm({ id: "0", name: "" });
    setEditing(false);
  };

  const handleBlur = (e) => {
    const value = e.target.value.trim();
    if (!value) return;

    const found = religions.some(
      (r) => r.religionName.toLowerCase() === value.toLowerCase(),
    );

    if (found) {
      setSnackbar({
        open: true,
        message: "Duplicate Religion!",
        severity: "error",
      });
      e.target.value = "";
      e.target.focus();
    } else {
      setForm((prev) => ({ ...prev, name: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const response = await religionService.create({
      ReligionId: form.id,
      ReligionName: form.name,
      OpFlag: editing ? "Update" : "Insert",
      UserName: sessionStorage.getItem("userEmail"), // ADD THIS
    });

    let vOutput = response.data.message.split(":");

    clear();
    fetchReligions();
    setOpen(false);

    setSnackbar({
      open: true,
      message: vOutput[0],
      severity: vOutput[1],
    });
  };

  const handleEdit = (row) => {
    setForm({ id: row.religionId, name: row.religionName });
    setEditing(true);
    setOpen(true);
  };
  const handleDelete = (id) => {
    setDeleteId(id);
    setConfirmOpen(true);
  };

  const confirmDelete = async () => {
    const response = await religionService.remove(deleteId, "Delete");
    let vOutput = response.data.message.split(":");

    fetchReligions();

    setSnackbar({
      open: true,
      message: vOutput[1],
      severity: vOutput[0],
    });

    setConfirmOpen(false);
  };

  const columns = [
    {
      field: "serialNo",
      headerName: "No.",
      width: 70,
      sortable: false,
      filterable: false,
      renderCell: (params) =>
        params.api.getRowIndexRelativeToVisibleRows(params.id) + 1,
    },
    { field: "religionId", headerName: "ID" },
    {
      field: "religionName",  
      headerName: "Religion Name",
      flex: 1,
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 220,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            height: "100%",
          }}
        >
          {/* <Button
      variant="outlined"
      color="success"
      size="small"
      startIcon={<ModeEditOutlineRoundedIcon />}
      onClick={() => handleEdit(params.row)}
      sx={{ pr: 2 }}
    >
      Edit
    </Button>

    <Button
      variant="outlined"
      color="error"
      size="small"
      startIcon={<DeleteRoundedIcon />}
      onClick={() => handleDelete(params.row.religionId)}
      sx={{ pr: 2 }}
    >
      Delete
    </Button> */}

          <Button
            variant="outlined"
            color="success"
            size="small"
            startIcon={<ModeEditOutlineRoundedIcon />}
            onClick={() => handleEdit(params.row)}
          >
            Edit
          </Button>

          <Button
            variant="outlined"
            color="error"
            size="small"
            startIcon={<DeleteRoundedIcon />}
            onClick={() => handleDelete(params.row.religionId)}
          >
            Delete
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="religion-grid-wrapper">
      <Box sx={{ p: 4 }}>
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Button
            variant="contained"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate("/Dashboard")}
          >
            Back To Home
          </Button>

          <Button variant="contained" onClick={() => setOpen(true)}>
            Add Religion
          </Button>
        </Box>

        <div className="datagrid-container">
          <DataGrid
            rows={religions}
            columns={columns}
            columnVisibilityModel={{
              religionId: false,
            }}
            getRowId={(row) => row.religionId}
            components={{ Toolbar: GridToolbar }}
          />
        </div>
      </Box>

      {/* Modal */}
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={{ p: 3, bgcolor: "#fff", m: "auto", mt: 10, width: 400 }}>
          <h4>{editing ? "Edit" : "Add"} Religion</h4>

          <form onSubmit={handleSubmit}>
            <TextField
              label="Religion Name"
              fullWidth
              required
              value={form.name}
              onChange={(e) =>
                setForm((prev) => ({ ...prev, name: e.target.value }))
              }
            />

            <Box mt={2} textAlign="right">
              <Button
                onClick={() => {
                  setOpen(false);
                  clear();
                }}
              >
                Cancel
              </Button>
              <Button type="submit" variant="contained">
                Save
              </Button>
            </Box>
          </form>
        </Box>
      </Modal>
      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this religion?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
          <Button onClick={confirmDelete} color="error" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ReligionManager;
